import { Alert, Typography } from "@mui/material";
import { useGetContactPersonQuery } from "../../store/services/communicationService";

interface ContactRequirementsProps {
  customerNo: number;
}

export const ContactRequirements = ({ customerNo }: ContactRequirementsProps) => {
  const { data: contactPersons, isLoading } = useGetContactPersonQuery(customerNo);

  if (isLoading || !contactPersons) return null;

  if (contactPersons.length === 0) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography variant="body2">
          <strong>Kontaktperson saknas.</strong> Lägg till minst en kontaktperson
          på kunden innan du kan gå vidare.
        </Typography>
      </Alert>
    );
  }

  if (!contactPersons.some((p) => p.IsResponsible)) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="body2">
          <strong>Avtalsansvarig saknas.</strong> Markera en kontaktperson som
          avtalsansvarig på kunden.
        </Typography>
      </Alert>
    );
  }

  return null;
};
